import React from "react";
import {autobind} from "core-decorators";
import {action, observable, runInAction} from "mobx";
import {inject, observer} from "mobx-react";
import {Button, Skeleton} from "antd";
import pluralize from "pluralize";

import "./Members.scss";
import ScoreCreditsModal from "./ScoreCreditsModal";
import Store from "@/stores";
import userCredits from "@/graphql/queries/userCredits";

export interface ISubscriptionManagementProps {
  store?: Store;
}

@inject("store")
@autobind
@observer
export default class SubscriptionManagement extends React.Component<ISubscriptionManagementProps> {
  @observable credits?: number;
  @observable scoreCreditsModalOpen: boolean = false;

  async componentDidMount() {
    await this.fetchCredits();
  }

  @action
  closeScoreCreditsModal() {
    this.scoreCreditsModalOpen = false;
    this.fetchCredits(); // re-fetch numbers of credits in case there has been a purchase
  }

  async fetchCredits() {
    const {apollo, session} = this.props.store!;
    const credits = await userCredits(apollo.client, session.user!.id);
    runInAction(() => (this.credits = credits));
  }

  @action
  openScoreCreditsModal() {
    this.scoreCreditsModalOpen = true;
  }

  render() {
    const {session} = this.props.store!;
    // Only show for Pro or Ensemble plan users
    if (!(session.hasPlanPro || session.hasPlanEnsemble)) return null;
    return (
      <div className="ScoreCredits">
        <h3>Score Credits</h3>
        <div className="current-credits">
          You can use any piece from our catalog for free. To upload your own scores, you need score credits.
          <br />
          You currently have{" "}
          <strong>
            {this.credits === undefined ? (
              <Skeleton.Input active style={{width: 20}} size="small" />
            ) : (
              pluralize("score credit", this.credits, true)
            )}
          </strong>{" "}
          available.
        </div>
        <Button onClick={this.openScoreCreditsModal}>Buy credits</Button>
        <ScoreCreditsModal
          credits={this.credits || 0}
          open={this.scoreCreditsModalOpen}
          close={this.closeScoreCreditsModal}
        />
      </div>
    );
  }
}
